/** Right column width for Schedule row and Hours row (% / burned). */
export const PCT_SLOT_WIDTH = 76;

/** Hours row: fixed card widths so Shop and Field columns line up. */
export const HOURS_BUDGET_CARD_PX = 104;
export const HOURS_ACTUAL_CARD_PX = 104;
export const HOURS_ROW_GAP_PX = 8;
/** Min height so Budget / Actual / % rows align vertically across Shop & Field. */
export const HOURS_CARD_MIN_HEIGHT_PX = 58;

/** Inset of stat value from card left edge (matches `p: 1` on cards). */
export const HOURS_CARD_CONTENT_INSET_PX = 8;

/** Left edge of earned-hours number = under Actual value (card + padding). */
export const EARNED_HOURS_VALUE_LEFT_PX =
  HOURS_BUDGET_CARD_PX + HOURS_ROW_GAP_PX + HOURS_CARD_CONTENT_INSET_PX;

/** Width reserved for earned % (matches MUI `TextField` small + % adornment, same as budget allocation). */
export const EARNED_PCT_INLINE_GROUP_PX = 104;
